import React, { useState, useContext } from "react";
import styled from "styled-components";
import BqnContext from "common/BqnContext";
import ModalsContext from "common/ModalsContext";
import Modal from "common/Modal";
import ChooseInstance, { getSelectedBqn } from "views/Administration/common/ChooseInstance";

const FooterError = styled.div`
  width: 100%;
  text-align: left;
  margin-bottom: 10px;
  margin-left: 5px;
`;

const Shutdown = () => {
  const {
    bqnId,
    loginBqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);
  const { closeModal } = useContext(ModalsContext);
  const [errorFooter, setErrorFooter] = useState("");
  const [bqnSelected, setBqnSelected] = useState(getSelectedBqn(bqnId, loginBqnId));
  const [loading, setLoading] = useState(false);

  const onApply = () => {
    setLoading(true);
    const cmdBqn = mode === "cluster" ? ` bqn-id ${bqnSelected}` : "";
    return ifCl
      .run(`system shutdown now force${cmdBqn}`)
      .then((response) => {
        setLoading(false);
        if (
          response && response.length > 1
        ) {
          if (response.match(/closed by remote host/) !== null){
            closeModal();
          } else {
            throw Error(`Error shutting down: ${response}`);
          }
        } else {
          closeModal();
        }
      })
      .catch((error) => {
        setLoading(false);
        setErrorFooter(`Error: ${error}`);
      });
  };

  return (
    <Modal
      title="Shutdown?"
      superIcon={"power_settings_new"}
      onClose={() => closeModal()}
      closeLabel={loading ? null : "CANCEL"}
      applyLabel={loading ? null : "YES"}
      onApply={() => onApply()}
      content={() => (
        <div>
          {mode === "cluster" ? (
            <div>
              <ChooseInstance action="shutdown" selected={bqnSelected} setSelected={setBqnSelected}/>
              {!loading ? (
                <div>
                  The BQN {bqnSelected} will be stopped and its traffic may be
                  interrupted.
                </div>
              ) : (
                <div>The BQN {bqnSelected} is being stopped.</div>
              )}
            </div>
          ) : !loading ? (
            <div>The BQN will be stopped and traffic may be interrupted.</div>
          ): (
            <div>The BQN is being stopped.</div>
          )}
        </div>
      )}
      footerMessage={
        errorFooter ? (
          <FooterError className="color-red">{errorFooter}</FooterError>
        ) : null
      }
    />
  );
};

export default Shutdown;
